$(function() {
  $('.header__button button').on('click', function (e) {
      e.preventDefault()

      $('.mobile-menu').slideToggle()
      $(this).toggleClass('up')
      $('body').toggleClass('overflow-hidden')
  })

  $('.mobile-menu > ul > li >a').on('click', function (e) {
      e.preventDefault()

      $(this).parent().find('ul').slideToggle()
      $(this).toggleClass('rotated')
  })

  let menuTo = null

  $('.header__menu__items__item__link').on('mouseenter', function () {
      $('.menu-dropdown').removeClass('menu-dropdown--active')
      if (menuTo !== null) {
          clearTimeout(menuTo)
          menuTo = null
      }
      $(this).parent().find('.menu-dropdown').addClass('menu-dropdown--active')
  })
  $('.menu-dropdown').on('mouseenter', function () {
      $('.menu-dropdown').removeClass('menu-dropdown--active')
      if (menuTo !== null) {
          clearTimeout(menuTo)
          menuTo = null
      }
      $(this).addClass('menu-dropdown--active')
  })
  $('.header__menu__items__item').on('mouseleave', function () {
      const self = $(this)
      if (menuTo !== null) {
          clearTimeout(menuTo)
          menuTo = null
      }
      menuTo = setTimeout(function () {
          self.find('.menu-dropdown').removeClass('menu-dropdown--active')
      }, 500)

  })

  $(document).on('scroll', function (e) {
      const st = $(this).scrollTop()

      if (st > 400) {
          if (!$('.header').hasClass('header--fixed')) {
              if ($('.header').hasClass('header--fp')) {
                  $('.contact-header').addClass('contact-header--fixed')
              }
              $('.header').attr('data-original-classes', $('.header').attr('class'))
              $('.header').hide()
              $('.header').fadeIn()
          }
          $('.header').addClass('header--fixed')
          $('.header').removeClass('header--white')
      } else {
          $('.contact-header').removeClass('contact-header--fixed')
          $('.header').attr('class', $('.header').attr('data-original-classes'))
          $('.contact-header').removeClass('contact-header--fixed')
      }
  })

  $('.video-container .play-btn').on('click', function(){
    $(this).parent().addClass('hidden').prev('video').get(0).play();
  })
})
